import { callLambda } from './lambda.js';
import { accountLaunchResult, type AccountLaunch } from './job-ledger-gate.js';

/**
 * Starts the caller's create-account workflow for a job of theirs that was refused with NO_LEDGER_ACCOUNT, or finds the
 * one already open, through public-ledger-account-launch. The server checks the job is the caller's, open, and needs
 * their own key. Refusals arrive as LambdaErrors carrying the lambda's message.
 */
export async function launchLedgerAccount(token: string | undefined, jobId: string): Promise<AccountLaunch> {
  const result = await callLambda('public-ledger/account-launch', 'POST', token, JSON.stringify({ jobId }));
  const launch = accountLaunchResult(result.res);
  if (!launch) throw new Error('Your public ledger account could not be started. Please try again.');
  return launch;
}
